import { AssetClassLevel } from "@app/const";

export const assetAllocationPages = {
  dashboard: "dashboard/*",
  getPortfolioGroupsUrl: () => `/asset-allocation/dashboard`,

  editPortfolioGroup: "edit-portfolio-group/:portfolioGroupId/*",

  getEditPortfolioGroupUrl: ({
    portfolioGroupId,
    isPublished,
  }: {
    portfolioGroupId: string;
    isPublished: boolean;
  }) =>
    `/asset-allocation/edit-portfolio-group/${portfolioGroupId}/${
      isPublished
        ? editPortfolioGroupPages.editCompare
        : editPortfolioGroupPages.assetClassSelection
    }`,

  viewPortfolioGroup:
    "view-portfolio-group/:portfolioGroupId/version/:portfolioGroupVersionId/*",

  getViewPortfolioGroupUrl: (
    portfolioGroupId: string,
    portfolioGroupVersionId: string,
  ) =>
    `/asset-allocation/view-portfolio-group/${portfolioGroupId}/version/${portfolioGroupVersionId}`,

  pdfSummaryReportPath: "pdf-summary-report",
  getPdfSummaryReportUrl: ({
    portfolioGroupId,
    data1Id,
  }: {
    portfolioGroupId: string;
    data1Id: string;
  }) =>
    `/asset-allocation/pdf-summary-report?portfolioGroupId=${portfolioGroupId}&data1Id=${data1Id}`,
  getPdfSummaryReportParams: (searchParams: URLSearchParams) => {
    const portfolioGroupId = searchParams.get("portfolioGroupId") ?? "";
    const data1Id = searchParams.get("data1Id") ?? "";

    return {
      portfolioGroupId,
      data1Id,
    };
  },

  pdfModuleSummaryReportPath: "pdf-module-summary-report",
  getPdfModuleSummaryReportUrl: ({
    portfolioGroupId,
    moduleId,
    data1Id,
    data2Id,
  }: {
    portfolioGroupId: string;
    moduleId: string;
    data1Id: string;
    data2Id: string;
  }) =>
    `/asset-allocation/pdf-module-summary-report?portfolioGroupId=${portfolioGroupId}&moduleId=${moduleId}&data1Id=${data1Id}&data2Id=${data2Id}`,
  getPdfModuleSummaryReportParams: (searchParams: URLSearchParams) => {
    const portfolioGroupId = searchParams.get("portfolioGroupId") ?? "";
    const moduleId = searchParams.get("moduleId") ?? "";
    const data1Id = searchParams.get("data1Id") ?? "";
    const data2Id = searchParams.get("data2Id") ?? "";

    return {
      portfolioGroupId,
      moduleId,
      data1Id,
      data2Id,
    };
  },

  // deprecated
  pdfPortfolioGroupPublishReportPath:
    "pdf-portfolio-group-publish-report/:portfolioGroupId/version/:portfolioGroupVersionId",
  getPdfPortfolioGroupPublishReportUrl: ({
    portfolioGroupId,
    portfolioGroupVersionId,
    xStatId,
    yStatId,
  }: {
    portfolioGroupId: string;
    portfolioGroupVersionId: string;
    xStatId: string;
    yStatId: string;
  }) =>
    `/asset-allocation/pdf-portfolio-group-publish-report/${portfolioGroupId}/version/${portfolioGroupVersionId}?x=${xStatId}&y=${yStatId}`,

  pdfModulePerformanceRiskReportPath: "pdf-module-performance-risk-report",
  getPdfModulePerformanceRiskReportUrl: ({
    portfolioGroupId,
    moduleId,
    data1Id,
    data2Id,
    startYear,
    endYear,
  }: {
    portfolioGroupId: string;
    moduleId: string;
    data1Id: string;
    data2Id: string;
    startYear: number;
    endYear: number;
  }) =>
    `/asset-allocation/pdf-module-performance-risk-report?portfolioGroupId=${portfolioGroupId}&moduleId=${moduleId}&data1Id=${data1Id}&data2Id=${data2Id}&startYear=${startYear}&endYear=${endYear}`,
  getPdfModulePerformanceRiskReportParams: (searchParams: URLSearchParams) => {
    const portfolioGroupId = searchParams.get("portfolioGroupId") ?? "";
    const moduleId = searchParams.get("moduleId") ?? "";
    const data1Id = searchParams.get("data1Id") ?? "";
    const data2Id = searchParams.get("data2Id") ?? "";
    const startYear = Number.parseInt(searchParams.get("startYear") ?? "0", 10);
    const endYear = Number.parseInt(searchParams.get("endYear") ?? "0", 10);

    return {
      portfolioGroupId,
      moduleId,
      data1Id,
      data2Id,
      startYear,
      endYear,
    };
  },

  pdfModuleMultiPeriodReturnReportPath: "pdf-module-multi-period-return-report",
  getPdfModuleMultiPeriodReturnReportUrl: ({
    portfolioGroupId,
    moduleId,
    data1Id,
    data2Id,
  }: {
    portfolioGroupId: string;
    moduleId: string;
    data1Id: string;
    data2Id: string;
  }) =>
    `/asset-allocation/pdf-module-multi-period-return-report?portfolioGroupId=${portfolioGroupId}&moduleId=${moduleId}&data1Id=${data1Id}&data2Id=${data2Id}`,
  getPdfModuleMultiPeriodReturnReportParams: (
    searchParams: URLSearchParams,
  ) => {
    const portfolioGroupId = searchParams.get("portfolioGroupId") ?? "";
    const moduleId = searchParams.get("moduleId") ?? "";
    const data1Id = searchParams.get("data1Id") ?? "";
    const data2Id = searchParams.get("data2Id") ?? "";

    return {
      portfolioGroupId,
      moduleId,
      data1Id,
      data2Id,
    };
  },

  pdfModuleSimulatedForwardProbabilitiesReportPath:
    "pdf-module-simulated-forward-probabilities-report",
  getPdfModuleSimulatedForwardProbabilitiesReportUrl: ({
    portfolioGroupId,
    moduleId,
    data1Id,
    data2Id,
    isReal,
    isCompare,
    chartDateRange1,
    chartDateRange2,
  }: {
    portfolioGroupId: string;
    moduleId: string;
    data1Id: string;
    data2Id: string;
    isReal: boolean;
    isCompare: boolean;
    chartDateRange1: number;
    chartDateRange2: number;
  }) =>
    `/asset-allocation/pdf-module-simulated-forward-probabilities-report?portfolioGroupId=${portfolioGroupId}&moduleId=${moduleId}&data1Id=${data1Id}&data2Id=${data2Id}&isReal=${isReal}&isCompare=${isCompare}&chartDateRange1=${chartDateRange1}&chartDateRange2=${chartDateRange2}`,
  getPdfModuleSimulatedForwardProbabilitiesReportParams: (
    searchParams: URLSearchParams,
  ) => {
    const portfolioGroupId = searchParams.get("portfolioGroupId") ?? "";
    const moduleId = searchParams.get("moduleId") ?? "";
    const data1Id = searchParams.get("data1Id") ?? "";
    const data2Id = searchParams.get("data2Id") ?? "";
    const isReal = JSON.parse(searchParams.get("isReal") ?? "false");
    const isCompare = JSON.parse(searchParams.get("isCompare") ?? "false");
    const chartDateRange1 = Number.parseInt(
      searchParams.get("chartDateRange1") ?? "20",
      10,
    );
    const chartDateRange2 = Number.parseInt(
      searchParams.get("chartDateRange2") ?? "20",
      10,
    );

    return {
      portfolioGroupId,
      moduleId,
      data1Id,
      data2Id,
      isReal,
      isCompare,
      chartDateRange1,
      chartDateRange2,
    };
  },

  pdfModuleScenarioAnalysisReportPath: "pdf-module-scenario-analysis-report",
  getPdfModuleScenarioAnalysisReportUrl: ({
    portfolioGroupId,
    moduleId,
    dataIds,
  }: {
    portfolioGroupId: string;
    moduleId: string;
    dataIds: string[];
  }) =>
    `/asset-allocation/pdf-module-scenario-analysis-report?portfolioGroupId=${portfolioGroupId}&moduleId=${moduleId}&dataIds=${dataIds.join(",")}`,
  getPdfModuleScenarioAnalysisReportParams: (searchParams: URLSearchParams) => {
    const portfolioGroupId = searchParams.get("portfolioGroupId") ?? "";
    const moduleId = searchParams.get("moduleId") ?? "";
    const dataIds = (searchParams.get("dataIds") ?? "").split(",");

    return {
      portfolioGroupId,
      moduleId,
      dataIds,
    };
  },

  pdfModuleSectorAnalysisReportPath: "pdf-module-sector-analysis-report",
  getPdfModuleSectorAnalysisReportUrl: ({
    portfolioGroupId,
    moduleId,
    data1Id,
    data2Id,
    sectorFocusId,
  }: {
    portfolioGroupId: string;
    moduleId: string;
    data1Id: string;
    data2Id: string;
    sectorFocusId: string;
  }) =>
    `/asset-allocation/pdf-module-sector-analysis-report?portfolioGroupId=${portfolioGroupId}&moduleId=${moduleId}&data1Id=${data1Id}&data2Id=${data2Id}&sectorFocusId=${sectorFocusId}`,
  getPdfModuleSectorAnalysisReportParams: (searchParams: URLSearchParams) => {
    const portfolioGroupId = searchParams.get("portfolioGroupId") ?? "";
    const moduleId = searchParams.get("moduleId") ?? "";
    const data1Id = searchParams.get("data1Id") ?? "";
    const data2Id = searchParams.get("data2Id") ?? "";
    const sectorFocusId = searchParams.get("sectorFocusId") ?? "";

    return {
      portfolioGroupId,
      moduleId,
      data1Id,
      data2Id,
      sectorFocusId,
    };
  },
};

export const portfolioAnalysisPages = {
  dashboard: "dashboard",
  geDashboardUrl: () => `/portfolio-analysis/dashboard`,

  editPortfolio: "edit-portfolio/:portfolioGroupId/*",

  getEditPortfolioUrl: (portfolioGroupId: string) =>
    `/portfolio-analysis/edit-portfolio/${portfolioGroupId}`,

  pdfSummaryReportPath: "pdf-summary-report",
  getPdfSummaryReportUrl: ({
    portfolioGroupId,
    moduleId,
    data1Id,
    data2Id,
  }: {
    portfolioGroupId: string;
    moduleId: string;
    data1Id: string;
    data2Id: string;
  }) =>
    `/portfolio-analysis/pdf-summary-report?portfolioGroupId=${portfolioGroupId}&moduleId=${moduleId}&data1Id=${data1Id}&data2Id=${data2Id}`,
  getPdfSummaryReportParams: (searchParams: URLSearchParams) => {
    const portfolioGroupId = searchParams.get("portfolioGroupId") ?? "";
    const moduleId = searchParams.get("moduleId") ?? "";
    const data1Id = searchParams.get("data1Id") ?? "";
    const data2Id = searchParams.get("data2Id") ?? "";

    return {
      portfolioGroupId,
      moduleId,
      data1Id,
      data2Id,
    };
  },

  pdfPerformanceRiskReportPath: "pdf-performance-risk-report",
  getPdfPerformanceRiskReportUrl: ({
    portfolioGroupId,
    moduleId,
    data1Id,
    data2Id,
    startYear,
    endYear,
  }: {
    portfolioGroupId: string;
    moduleId: string;
    data1Id: string;
    data2Id: string;
    startYear: number;
    endYear: number;
  }) =>
    `/portfolio-analysis/pdf-performance-risk-report?portfolioGroupId=${portfolioGroupId}&moduleId=${moduleId}&data1Id=${data1Id}&data2Id=${data2Id}&startYear=${startYear}&endYear=${endYear}`,
  getPdfPerformanceRiskReportParams: (searchParams: URLSearchParams) => {
    const portfolioGroupId = searchParams.get("portfolioGroupId") ?? "";
    const moduleId = searchParams.get("moduleId") ?? "";
    const data1Id = searchParams.get("data1Id") ?? "";
    const data2Id = searchParams.get("data2Id") ?? "";
    const startYear = Number.parseInt(searchParams.get("startYear") ?? "0", 10);
    const endYear = Number.parseInt(searchParams.get("endYear") ?? "0", 10);

    return {
      portfolioGroupId,
      moduleId,
      data1Id,
      data2Id,
      startYear,
      endYear,
    };
  },

  pdfMultiPeriodReturnReportPath: "pdf-multi-period-return-report",
  getPdfMultiPeriodReturnReportUrl: ({
    portfolioGroupId,
    moduleId,
    data1Id,
    data2Id,
  }: {
    portfolioGroupId: string;
    moduleId: string;
    data1Id: string;
    data2Id: string;
  }) =>
    `/portfolio-analysis/pdf-multi-period-return-report?portfolioGroupId=${portfolioGroupId}&moduleId=${moduleId}&data1Id=${data1Id}&data2Id=${data2Id}`,
  getPdfMultiPeriodReturnReportParams: (searchParams: URLSearchParams) => {
    const portfolioGroupId = searchParams.get("portfolioGroupId") ?? "";
    const moduleId = searchParams.get("moduleId") ?? "";
    const data1Id = searchParams.get("data1Id") ?? "";
    const data2Id = searchParams.get("data2Id") ?? "";

    return {
      portfolioGroupId,
      moduleId,
      data1Id,
      data2Id,
    };
  },

  pdfSimulatedForwardProbabilitiesReportPath:
    "pdf-simulated-forward-probabilities-report",
  getPdfSimulatedForwardProbabilitiesReportUrl: ({
    portfolioGroupId,
    moduleId,
    data1Id,
    data2Id,
    isReal,
    isCompare,
    chartDateRange1,
    chartDateRange2,
  }: {
    portfolioGroupId: string;
    moduleId: string;

    data1Id: string;
    data2Id: string;
    isReal: boolean;
    isCompare: boolean;
    chartDateRange1: number;
    chartDateRange2: number;
  }) =>
    `/portfolio-analysis/pdf-simulated-forward-probabilities-report?portfolioGroupId=${portfolioGroupId}&moduleId=${moduleId}&data1Id=${data1Id}&data2Id=${data2Id}&isReal=${isReal}&isCompare=${isCompare}&chartDateRange1=${chartDateRange1}&chartDateRange2=${chartDateRange2}`,
  getPdfSimulatedForwardProbabilitiesReportParams: (
    searchParams: URLSearchParams,
  ) => {
    const portfolioGroupId = searchParams.get("portfolioGroupId") ?? "";
    const moduleId = searchParams.get("moduleId") ?? "";
    const data1Id = searchParams.get("data1Id") ?? "";
    const data2Id = searchParams.get("data2Id") ?? "";
    const isReal = JSON.parse(searchParams.get("isReal") ?? "false");
    const isCompare = JSON.parse(searchParams.get("isCompare") ?? "false");
    const chartDateRange1 = Number.parseInt(
      searchParams.get("chartDateRange1") ?? "20",
      10,
    );
    const chartDateRange2 = Number.parseInt(
      searchParams.get("chartDateRange2") ?? "20",
      10,
    );

    return {
      portfolioGroupId,
      moduleId,
      data1Id,
      data2Id,
      isReal,
      isCompare,
      chartDateRange1,
      chartDateRange2,
    };
  },

  pdfScenarioAnalysisReportPath: "pdf-scenario-analysis-report",
  getPdfScenarioAnalysisReportUrl: ({
    portfolioGroupId,
    moduleId,
    dataIds,
  }: {
    portfolioGroupId: string;
    moduleId: string;
    dataIds: string[];
  }) =>
    `/portfolio-analysis/pdf-scenario-analysis-report?portfolioGroupId=${portfolioGroupId}&moduleId=${moduleId}&dataIds=${dataIds.join(",")}`,
  getPdfScenarioAnalysisReportParams: (searchParams: URLSearchParams) => {
    const portfolioGroupId = searchParams.get("portfolioGroupId") ?? "";
    const moduleId = searchParams.get("moduleId") ?? "";
    const dataIds = (searchParams.get("dataIds") ?? "").split(",");

    return {
      portfolioGroupId,
      moduleId,
      dataIds,
    };
  },

  pdfSectorAnalysisReportPath: "pdf-sector-analysis-report",
  getPdfSectorAnalysisReportUrl: ({
    portfolioGroupId,
    moduleId,
    data1Id,
    data2Id,
    sectorFocusId,
  }: {
    portfolioGroupId: string;
    moduleId: string;
    data1Id: string;
    data2Id: string;
    sectorFocusId: string;
  }) =>
    `/portfolio-analysis/pdf-sector-analysis-report?portfolioGroupId=${portfolioGroupId}&moduleId=${moduleId}&data1Id=${data1Id}&data2Id=${data2Id}&sectorFocusId=${sectorFocusId}`,
  getPdfSectorAnalysisReportParams: (searchParams: URLSearchParams) => {
    const portfolioGroupId = searchParams.get("portfolioGroupId") ?? "";
    const moduleId = searchParams.get("moduleId") ?? "";
    const data1Id = searchParams.get("data1Id") ?? "";
    const data2Id = searchParams.get("data2Id") ?? "";
    const sectorFocusId = searchParams.get("sectorFocusId") ?? "";

    return {
      portfolioGroupId,
      moduleId,
      data1Id,
      data2Id,
      sectorFocusId,
    };
  },
};

export const financialPlanningPages = {
  clientListPath: "client-list",
  clientListUrl: "/financial-planning/client-list",
  addClientPath: "add-client",
  addClientUrl: "/financial-planning/add-client",

  clientSummaryPath: ":clientId/summary",
  getClientSummaryUrl: (clientId: string) =>
    `/financial-planning/${clientId}/summary`,

  planInputPath: ":clientId/plan/:planId/plan-input",
  getPlanInputUrl: (clientId: string, planId: string) =>
    `/financial-planning/${clientId}/plan/${planId}/plan-input`,

  workbenchPath: ":clientId/plan/:planId/workbench/type/:planTypeId/*",
  getWorkbenchUrl: (clientId: string, planId: string, planTypeId: string) =>
    `/financial-planning/${clientId}/plan/${planId}/workbench/type/${planTypeId}`,

  progressMonitoringPath: ":clientId/progress-monitoring",
  getProgressMonitoringUrl: (clientId: string) =>
    `/financial-planning/${clientId}/progress-monitoring`,

  pdfPlanningReportPath:
    "pdf-planning-report/:clientId/plan/:planId/type/:planTypeId",
  getPdfPlanningReportUrl: ({
    clientId,
    planId,
    planTypeId,
  }: {
    clientId: string;
    planId: string;
    planTypeId: string;
  }) =>
    `/financial-planning/pdf-planning-report/${clientId}/plan/${planId}/type/${planTypeId}`,

  pdfActionReportPath:
    "pdf-action-report/:clientId/plan/:planId/type/:planTypeId",
  getPdfActionReportUrl: ({
    clientId,
    planId,
    planTypeId,
  }: {
    clientId: string;
    planId: string;
    planTypeId: string;
  }) =>
    `/financial-planning/pdf-action-report/${clientId}/plan/${planId}/type/${planTypeId}`,

  translucenceChatPath: "translucence-chat/:planResultRootId/:planResultTypeId",
  getTranslucenceChatUrl: (
    planResultRootId: string,
    planResultTypeId: string,
  ) =>
    `/financial-planning/translucence-chat/${planResultRootId}/${planResultTypeId}`,

  xaiChatPath: "xai-chat/:planResultRootId/:planResultTypeId",
  getXAIChatUrl: (
    planResultRootId: string,
    planResultTypeId: string,
  ) =>
    `/financial-planning/xai-chat/${planResultRootId}/${planResultTypeId}`,

  polarisChatPath: "polaris-chat/:planResultRootId/:planResultTypeId",
  getPolarisChatUrl: (
    planResultRootId: string,
    planResultTypeId: string,
  ) =>
    `/financial-planning/polaris-chat/${planResultRootId}/${planResultTypeId}`,

  planGuidePath: "plan-guide/:planResultRootId/:planResultTypeId",
  getPlanGuideUrl: (planResultRootId: string, planResultTypeId: string) =>
    `/financial-planning/plan-guide/${planResultRootId}/${planResultTypeId}`,

  meetingGuidancePath: "meeting-guidance/:planResultRootId/:planResultTypeId",
  getMeetingGuidanceUrl: (
    planResultRootId: string,
    planResultTypeId: string,
  ) =>
    `/financial-planning/meeting-guidance/${planResultRootId}/${planResultTypeId}`,

  meetingGuidanceSignalCatalogPath:
    "meeting-guidance/:planResultRootId/:planResultTypeId/signals",
  getMeetingGuidanceSignalCatalogUrl: (
    planResultRootId: string,
    planResultTypeId: string,
  ) =>
    `/financial-planning/meeting-guidance/${planResultRootId}/${planResultTypeId}/signals`,

  thesysDemoPath: "thesys-demo/:planResultRootId/:planResultTypeId",
  getThesysDemoUrl: (planResultRootId: string, planResultTypeId: string) =>
    `/financial-planning/thesys-demo/${planResultRootId}/${planResultTypeId}`,

  promptResearchPath: "prompt-research/:planResultRootId/:planResultTypeId",
  getPromptResearchUrl: (planResultRootId: string, planResultTypeId: string) =>
    `/financial-planning/prompt-research/${planResultRootId}/${planResultTypeId}`,
};

export const settingsPages = {
  notifications: "notifications",
  userSettings: "user-settings",
  firmSettings: "firm-settings",
  disclosuresUrl: "disclosures",
  disclosuresPath: "disclosures/*",
  billing: "billing",
  assetClassSettings: "asset-class-settings",
  backEndUrl: "back-end",
  backEndPath: "back-end/*",
};

export const notificationsPage = {
  new: "new",
  cleared: "cleared",
};

export const rootPages = {
  login: "login",
  startFreeTrial: "start-free-trial",
  logout: "logout", // no such page just url to display on link hover
  home: "/",

  notificationsUrl: "/notifications",
  notificationsPath: "notifications/*",

  settingsUrl: "/settings",
  settingsPath: "settings/*",

  debug: "/debug",
  debugPdf: "/debug-pdf",
  debugIcons: "/debug-icons",
  contactUs: "contact-us",

  payment: "/payment",
  paymentComplete: "/payment-complete",

  acceptInvitationPath: "/accept-invitation/:invitationSecret",

  resetPasswordPath: "/reset-password/:resetPasswordToken",

  simulationUrl: "/simulation",
  simulationPath: "simulation/*",

  assetClassAnalysisUrl: "/asset-class-analysis",
  assetClassAnalysisPath: "asset-class-analysis/*",

  assetAllocationUrl: "/asset-allocation",
  assetAllocationPath: "asset-allocation/*",

  financialPlanningUrl: "financial-planning",
  financialPlanningPath: "financial-planning/*",

  portfolioAnalysisUrl: "portfolio-analysis",
  portfolioAnalysisPath: "portfolio-analysis/*",
};

export const editPortfolioGroupPages = {
  assetClassSelection: "asset-class-selection",
  createAllocations: "create-allocations",
  optimization: "optimization",
  editCompare: "edit-compare",
  analyze: "analyze",
  selection: "selection",
  reportsPath: "reports/*",
  reportsUrl: "reports",
  publish: "publish",
};

export const editPortfolioPages = {
  assetClassSelection: "asset-class-selection",
  createModel: "create-model",
  optimization: "optimization",
  editCompare: "edit-compare",
  analyze: "analyze",
};

export const viewPortfolioGroupPages = {
  summary: "summary",
  analyze: "analyze",
};

export const assetClassAnalysisPages = {
  dashboard: "dashboard",
  analyzeUrl: "analyze",
  analyzePath: "analyze/*",

  pdfSummaryReportPath: "pdf-summary-report",
  getPdfSummaryReportUrl: ({
    assetClassGroupId,
    xStatId,
    yStatId,
    pageId,
    isReal,
  }: {
    assetClassGroupId: string;
    xStatId: string;
    yStatId: string;
    pageId: string;
    isReal: boolean;
  }) =>
    `/asset-class-analysis/pdf-summary-report?assetClassGroupId=${assetClassGroupId}&xStatId=${xStatId}&yStatId=${yStatId}&pageId=${pageId}&isReal=${isReal}`,
  getPdfSummaryReportParams: (searchParams: URLSearchParams) => {
    const assetClassGroupId = searchParams.get("assetClassGroupId") ?? "";
    const isReal = JSON.parse(searchParams.get("isReal") ?? "false");
    const xStatId = searchParams.get("xStatId") ?? "";
    const yStatId = searchParams.get("yStatId") ?? "";
    const pageId = searchParams.get("pageId") ?? "";

    return {
      assetClassGroupId,
      xStatId,
      yStatId,
      pageId,
      isReal,
    };
  },

  pdfMultiPeriodReturnReportPath: "pdf-multi-period-return-report",
  getPdfMultiPeriodReturnReportUrl: ({
    assetClass1Id,
    assetClass2Id,
  }: {
    assetClass1Id: string;
    assetClass2Id: string;
  }) =>
    `/asset-class-analysis/pdf-multi-period-return-report?assetClass1Id=${assetClass1Id}&assetClass2Id=${assetClass2Id}`,
  getPdfMultiPeriodReturnReportParams: (searchParams: URLSearchParams) => {
    const assetClass1Id = searchParams.get("assetClass1Id") ?? "";
    const assetClass2Id = searchParams.get("assetClass2Id") ?? "";

    return {
      assetClass1Id,
      assetClass2Id,
    };
  },

  pdfDistanceFromTrendReportPath: "pdf-distance-from-trend-report",
  getPdfDistanceFromTrendReportUrl: ({
    assetClass1Id,
    assetClass2Id,
    isCompare,
  }: {
    assetClass1Id: string;
    assetClass2Id: string;
    isCompare: boolean;
  }) =>
    `/asset-class-analysis/pdf-distance-from-trend-report?assetClass1Id=${assetClass1Id}&assetClass2Id=${assetClass2Id}&isCompare=${isCompare}`,
  getPdfDistanceFromTrendReportParams: (searchParams: URLSearchParams) => {
    const assetClass1Id = searchParams.get("assetClass1Id") ?? "";
    const assetClass2Id = searchParams.get("assetClass2Id") ?? "";
    const isCompare = JSON.parse(searchParams.get("isCompare") ?? "false");

    return {
      assetClass1Id,
      assetClass2Id,
      isCompare,
    };
  },

  pdfPerformanceRiskReportPath: "pdf-performance-risk-report",
  getPdfPerformanceRiskReportUrl: ({
    assetClass1Id,
    assetClass2Id,
    startYear,
    endYear,
  }: {
    assetClass1Id: string;
    assetClass2Id: string;
    startYear: number;
    endYear: number;
  }) =>
    `/asset-class-analysis/pdf-performance-risk-report?assetClass1Id=${assetClass1Id}&assetClass2Id=${assetClass2Id}&startYear=${startYear}&endYear=${endYear}`,
  getPdfPerformanceRiskReportParams: (searchParams: URLSearchParams) => {
    const assetClass1Id = searchParams.get("assetClass1Id") ?? "";
    const assetClass2Id = searchParams.get("assetClass2Id") ?? "";
    const startYear = Number.parseInt(searchParams.get("startYear") ?? "0", 10);
    const endYear = Number.parseInt(searchParams.get("endYear") ?? "0", 10);

    return {
      assetClass1Id,
      assetClass2Id,
      startYear,
      endYear,
    };
  },

  pdfIndexCompareReportPath: "pdf-index-compare-report",
  getPdfIndexCompareReportUrl: ({
    assetClass1Id,
    assetClass2Id,
    assetClass3Id,
  }: {
    assetClass1Id: string;
    assetClass2Id: string;
    assetClass3Id: string;
  }) =>
    `/asset-class-analysis/pdf-index-compare-report?assetClass1Id=${assetClass1Id}&assetClass2Id=${assetClass2Id}&assetClass3Id=${assetClass3Id}`,
  getPdfIndexCompareReportParams: (searchParams: URLSearchParams) => {
    const assetClass1Id = searchParams.get("assetClass1Id") ?? "";
    const assetClass2Id = searchParams.get("assetClass2Id") ?? "";
    const assetClass3Id = searchParams.get("assetClass3Id") ?? "";

    return {
      assetClass1Id,
      assetClass2Id,
      assetClass3Id,
    };
  },

  pdfSectorAnalysisReportPath: "pdf-sector-analysis-report",
  getPdfSectorAnalysisReportUrl: ({
    assetClass1Id,
    assetClass2Id,
    sectorFocusId,
  }: {
    assetClass1Id: string;
    assetClass2Id: string;
    sectorFocusId: string;
  }) =>
    `/asset-class-analysis/pdf-sector-analysis-report?assetClass1Id=${assetClass1Id}&assetClass2Id=${assetClass2Id}&sectorFocusId=${sectorFocusId}`,
  getPdfSectorAnalysisReportParams: (searchParams: URLSearchParams) => {
    const assetClass1Id = searchParams.get("assetClass1Id") ?? "";
    const assetClass2Id = searchParams.get("assetClass2Id") ?? "";
    const sectorFocusId = searchParams.get("sectorFocusId") ?? "";

    return {
      assetClass1Id,
      assetClass2Id,
      sectorFocusId,
    };
  },

  pdfSimulatedForwardProbabilitiesReportPath:
    "pdf-simulated-forward-probabilities-report",
  getPdfSimulatedForwardProbabilitiesReportUrl: ({
    assetClass1Id,
    assetClass2Id,
    isReal,
    isAdvanced,
    chartDateRange1,
    chartDateRange2,
  }: {
    assetClass1Id: string;
    assetClass2Id: string;
    isReal: boolean;
    isAdvanced: boolean;
    chartDateRange1: number;
    chartDateRange2: number;
  }) =>
    `/asset-class-analysis/pdf-simulated-forward-probabilities-report?assetClass1Id=${assetClass1Id}&assetClass2Id=${assetClass2Id}&isReal=${isReal}&isAdvanced=${isAdvanced}&chartDateRange1=${chartDateRange1}&chartDateRange2=${chartDateRange2}`,
  getPdfSimulatedForwardProbabilitiesReportParams: (
    searchParams: URLSearchParams,
  ) => {
    const assetClass1Id = searchParams.get("assetClass1Id") ?? "";
    const assetClass2Id = searchParams.get("assetClass2Id") ?? "";
    const isReal = JSON.parse(searchParams.get("isReal") ?? "false");
    const isAdvanced = JSON.parse(searchParams.get("isAdvanced") ?? "false");
    const chartDateRange1 = Number.parseInt(
      searchParams.get("chartDateRange1") ?? "20",
      10,
    );
    const chartDateRange2 = Number.parseInt(
      searchParams.get("chartDateRange2") ?? "20",
      10,
    );

    return {
      assetClass1Id,
      assetClass2Id,
      isReal,
      isAdvanced,
      chartDateRange1,
      chartDateRange2,
    };
  },
};

export const assetClassAnalysisAnalyzePages = {
  summary: "summary",
  historicalAnalysisPath: "historical-analysis/*",
  historicalAnalysisUrl: "historical-analysis",
  forwardLookingAnalysisPath: "forward-looking-analysis/*",
  forwardLookingAnalysisUrl: "forward-looking-analysis",
};

export const assetClassAnalysisAnalyzeHistoricalAnalysisPages = {
  performanceRisk: "performance-risk",
  multiPeriodReturn: "multi-period-return",
  distanceFromTrend: "distance-from-trend",
  indexCompare: "index-compare",
  sectorAnalysis: "sector-analysis",
};

export const assetClassAnalysisAnalyzeForwardLookingAnalysisPages = {
  simulatedForwardProbabilities: "simulated-forward-probabilities",
  correlations: "correlations",
};

export const simulationPages = {
  priceDrivenUrl: "price-driven",
  priceDrivenPath: "price-driven/*",
  staticUrl: "static",
  staticPath: "static/*",
  modelsUrl: "models",
  modelsPath: "models/*",
  abTestUrl: "ab-test",
  abTestPath: "ab-test/*",
  runUrl: "run",
  runPath: "run/*",
  pdfModelsModelsReportPath: "pdf-models-models-report",
  getPdfModelsModelsReportUrl: ({
    assetClassId,
    isStatic,
    modelVersionId,
    regressionResultItemIndex,
  }: {
    assetClassId: string;
    isStatic: boolean;
    modelVersionId: string;
    regressionResultItemIndex: number;
  }) =>
    `/simulation/pdf-models-models-report?assetClassId=${assetClassId}&isStatic=${isStatic}&modelVersionId=${modelVersionId}&regressionResultItemIndex=${regressionResultItemIndex}`,
  getPdfModelsModelsReportParams: (searchParams: URLSearchParams) => {
    const assetClassId = searchParams.get("assetClassId") ?? "";
    const isStatic = JSON.parse(searchParams.get("isStatic") ?? "false");
    const modelVersionId = searchParams.get("modelVersionId") ?? "";
    const regressionResultItemIndex = Number.parseInt(
      searchParams.get("regressionResultItemIndex") ?? "0",
      10,
    );

    return {
      assetClassId,
      isStatic,
      modelVersionId,
      regressionResultItemIndex,
    };
  },
};
